import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, filename: String }

  connect() {
    this._handleBeforeUnload = this._warnIfBusy.bind(this)
  }

  disconnect() {
    window.removeEventListener('beforeunload', this._handleBeforeUnload)
  }

  async download(event) {
    const button = event.currentTarget
    if (button.dataset.busy === 'true') return

    button.dataset.busy = 'true'
    const originalHTML = button.innerHTML
    button.innerHTML = this._spinner()
    button.disabled = true
    window.addEventListener('beforeunload', this._handleBeforeUnload)

    try {
      const productId = button.dataset.productId
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set('product_id', productId)

      const response = await fetch(url.toString(), {
        method: 'POST',
        redirect: 'error',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      })

      if (!response.ok) {
        const json = await response.json().catch(() => ({}))
        alert(`Mockup failed: ${json.error || response.statusText}`)
        return
      }

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = this.hasFilenameValue ? this.filenameValue : 'mockup.png'
      a.click()
      URL.revokeObjectURL(objectUrl)
    }
    catch (e) {
      alert(`Mockup download failed: ${e.message}`)
    }
    finally {
      button.innerHTML = originalHTML
      button.disabled = false
      delete button.dataset.busy
      window.removeEventListener('beforeunload', this._handleBeforeUnload)
    }
  }

  _warnIfBusy(event) {
    event.preventDefault()
    event.returnValue = 'A mockup is still generating — leaving now will cancel it.'
  }

  _spinner() {
    return `<svg class="animate-spin h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
    </svg>`
  }
}
